<template>
    <div>
        <div class="notice">
            {{ $t(info) }}
        </div>
        <Illustration xl :image="illustrationPath"/>
        <div class="button-group">
            <button
                class="btn btn__primary btn__primary--dark btn--block"
                type="button"
                @click="closeModal"
            >
                {{ $t('close') | capitalize }}
            </button>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        name: 'InfoModal',
        props: {
            info: {
                type: String,
                required: true,
            },
            illustrationPath: {
                type: String,
                required: true,
            }
        },
        methods: {
            ...mapActions('ui/modal', [
                'closeModal'
            ]),
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/modals/modals/InfoModal.vue